// extracted by mini-css-extract-plugin
export default {"overlay":"NavigationOverlay_overlay__r1oWv"};